import * as Sentry from "@sentry/vue";
import { Environment } from "./services/Environment";

function parseBooleanEnv(value, defaultValue) {
    const normalizedValue = value?.trim().toLowerCase();
    if (normalizedValue === "true") {
        return true;
    }

    if (normalizedValue === "false") {
        return false;
    }

    return defaultValue;
}

function parseNumberEnv(value, defaultValue) {
    if (value === undefined) {
        return defaultValue;
    }

    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : defaultValue;
}

export default (vue) => Sentry.init({
    Vue: vue,
    dsn: Environment.get("VUE_APP_SENTRY_DSN"),
    enabled: parseBooleanEnv(Environment.get("VUE_APP_SENTRY_ENABLED"), true),
    environment: Environment.get("VUE_APP_SENTRY_ENVIRONMENT"),
    sampleRate: parseNumberEnv(Environment.get("VUE_APP_SENTRY_SAMPLE_RATE"), 1),
    sendDefaultPii: parseBooleanEnv(Environment.get("VUE_APP_SENTRY_SEND_DEFAULT_PII"), false),
    attachStacktrace: parseBooleanEnv(Environment.get("VUE_APP_SENTRY_ATTACH_STACK_TRACE"), false),
    integrations: [Sentry.captureConsoleIntegration({ levels: ["error"] })]
});